import { render } from "./CrashBetElement.vue?vue&type=template&id=4351c15d&scoped=true"
import script from "./CrashBetElement.vue?vue&type=script&lang=js"
export * from "./CrashBetElement.vue?vue&type=script&lang=js"

import "./CrashBetElement.vue?vue&type=style&index=0&id=4351c15d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4351c15d"]])

export default __exports__